import ActivityTypeColors from '@/v2/domains/Activities/constants/colors.js';

const Colors = {
  primary: '#0E76BB',
  text: '#596F85',
  textDark: '#464646',
  textDarkComic: '#585858',
  textBlack: '#15043B',
  textShadow: '#00228080',
  textAccent: '#A60832',
  background: '#FFFFFF',
  backgroundPaleBlue: '#F3F7FB',
  backgroundPaleBlueDark: '#E5F0FB',
  backgroundPalerBlueDark: '#f2f7fd',
  secondBackground: '#fafafa',
  darkBackground: '#f5f5f5',
  border: '#CACDDB',
  borderLight: '#ECECF2',
  disabled: '#f5f5f5',
  gray: '#8E8E8E',
  darkGray: '#303030',
  darkerGray: '#1f1f1f',
  mediumGray: '#c0c0c0',
  lightGray: '#a0a0a0',
  lighterGray: '#cbcdda',
  evenLighterGray: '#e0e0e0',
  purple: '#a84a8e',
  blue: '#007EB0',
  lightBlue: '#99e0ff',
  lighterBlue: '#c2e4ff',
  greenishBlue: '#02A09A',
  pink: '#D43B6E',
  success: '#4dc4ad',
  error: '#db5547',
  darkBlue: '#0d4171',
  green: '#4dc4ad',
  red: '#db5547',
  darkRed: '#B32D10',
  orange: '#f7a100',
  buttonGray: '#737072',

  hoverBackground: '#eef8ff',
  boxShadowGray: '#15223214',
  boxShadowBlack: '#00000014',
  darkGreen: '#35ab2c',
  darkGreenBackground: '#35ab2c33',
  lightGreen: '#95bf1f',
  invertedForeground: 'white',

  redBackground: '#e7322833',
  greenRadioBackground: '#54AA2C33',
  darkGreenBackground: '#35ab2c33',
  activityTypeColors: { ...ActivityTypeColors, themes: '#A84A8E' },
  subscriptionStatusTagColors: {
    active: 'green',
    expired: 'red',
  },
  subscriptionPaymentStatusTagColors: {
    pending: 'blue',
    success: 'green',
    error: 'red',
  },
  subscriptionTypeTagColors: {
    family: '#FA007F',
    teacher: '#00BCEB',
    teacherPro: '#0d4171',
  },
  providerColors: {
    google: 'gold',
    classlink: 'lime',
    clever: 'geekblue',
    password: 'red',
  },
  home: {
    background1: '#a6e0e1',
    background2: '#eeeeee',
    background3: '#00a19c',
    specialColor: '#008aae',
  },
  correctness: {
    60: '#54AA2C',
    30: '#f7a100',
    0: '#e73228',
  },
  template: {
    easy: '#9FF49C',
    medium: '#FEC34E',
    hard: '#DB5547',
  },
  providerBackgrounds: {
    clever: '#436CF2',
    classlink: '#0B4D7F',
    google: '#FFFFFF',
  },
  boxShadow: `0px 1px 4px 0px rgba(0, 0, 20, 0.12)`,
  blueBoxShadow: `0px 1px 4px 0px rgba(13, 65, 113, 0.2)`,
  boxShadowActivityPreview: `-0px -2px 2px 0px rgba(0, 0, 20, 0.12)`,
  blueBoxShadowActivityPreview: `-0px -2px 2px 0px rgba(0, 0, 20, 0.2)`,
};

Colors.playerControlsThemes = {
  default: {
    background: '#10101160', //Colors.playerControlsBackground,
    backgroundHover: '#10101199',
    foreground: Colors.evenLighterGray,
    lightForeground: Colors.evenLighterGray,
    buttonsForeground: Colors.secondBackground,
    buttonsForegroundHover: Colors.secondBackground,
    buttonsBackground: '#50505070',
    buttonsBackgroundHover: '#303030a0',
    progressBarBgColor: '#00000050',
    progressBarColor: Colors.blue,
    bufferBarColor: '#80808060',
    textBackground: '#00000060',
  },

  inverted: {
    background: '#10101170',
    backgroundHover: '#101011FF',
    foreground: Colors.evenLighterGray,
    lightForeground: Colors.evenLighterGray,
    buttonsForeground: Colors.secondBackground,
    buttonsForegroundHover: Colors.secondBackground,
    buttonsBackground: '#505050CC',
    buttonsBackgroundHover: '#303030FF',
    progressBarBgColor: '#00000050',
    progressBarColor: Colors.blue,
    bufferBarColor: '#80808060',
    textBackground: '#00000060',
  },
};

export default Colors;
